export default __webpack_public_path__ + "static/media/logo_dark.45338a74.svg";